import { RadioGroup } from 'enova-frontend-components';
import { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldError } from 'react-hook-form';

interface Props {
  children: ReactElement[] | ReactElement;
  labelKey?: string;
  helperTextKey?: string;
  error?: FieldError;
  value?: string;
  onChange: (value: string) => void;
}

export const EnumRadioGroup: FC<Props> = ({ children, labelKey, helperTextKey, error, value, onChange }) => {
  const { t } = useTranslation();

  const helperBoxProps = helperTextKey
    ? {
        'aria-label': t('readFieldInformation'),
        children: t(`${helperTextKey}`)
      }
    : undefined;

  return (
    <RadioGroup
      row
      label={labelKey && t(labelKey)}
      aria-label={labelKey && t(labelKey)}
      HelperBoxProps={helperBoxProps}
      marginBottom
      error={!!error}
      helperText={error && t(`${error.message}`)}
      value={value ?? null}
      onChange={(_, value) => onChange(value)}
    >
      {children}
    </RadioGroup>
  );
};
